module.exports = __webpack_public_path__ + "static/media/pdf.a5acc78d.svg";